module.exports = __webpack_public_path__ + "img/134.5c0c36d6.jpg";